import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { LeadPriorityService } from './lead-priority.service';

@Component({
  selector: 'app-lead-priority',
  templateUrl: './lead-priority.component.html',
  styleUrls: ['./lead-priority.component.css'],
})
export class LeadPriorityComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'lead_priority',
    'createdAt',
    'updatedAt',
    'status',
    // 'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  leadPriority: FormGroup;
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private leadPriorityService: LeadPriorityService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.leadPriority = this.fb.group({
      status: ['', Validators.required],
      lead_priority: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.getLeadPriorityList();
  }

  getLeadPriorityList() {
    this.isLoading.next(true);
    this.leadPriorityService.getLeadPriorityList().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    if (this.leadPriority.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.leadPriorityService
          .updateLeadPriorityMaster(this.selectedId, this.leadPriority.value)
          .subscribe(
            (response) => {
              this.toastr.success('Lead Priority updated successfully');
              this.clearForm();
              this.isEdit = false;
              this.getLeadPriorityList();
              this.isLoading.next(false);
            },
            (error) => {
              this.toastr.error('Error updating Lead Priority');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.leadPriorityService
        .createLeadPriorityMaster(this.leadPriority.value)
        .subscribe(
          (response) => {
            this.toastr.success('Lead Priority created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getLeadPriorityList();
            this.isLoading.next(false);
          },
          (error) => {
            this.toastr.error('Error creating Lead Priority');
            this.isLoading.next(false);
          }
        );
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    this.leadPriority.patchValue({
      status: element.status ? 1 : 0,
      lead_priority: element.lead_priority,
    });
  }

  clearForm() {
    this.submitted = false;
    this.leadPriority.patchValue({
      status: '',
      lead_priority: '',
    });
    this.selectedId = null;
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getLeadPriorityList();
  }
}
